import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from "../app.service";

@Component({
  selector: "app-user-dashboard",
  standalone: false,
  templateUrl: "./user-dashboard.component.html",
  styleUrls: ["./user-dashboard.component.css"],
})
export class UserDashboardComponent implements OnInit {
  userKey: string = "";
  userName: string = "";
  apiKey: any;
  workspaceName: any;
  status: any;

  totalMemories: number = 0;
  totalTags: number = 0;
  tags: string[] = [];

  loading: boolean = true;
  showErrorMsg: boolean = false;
  showErrorText: string = "";

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public appService: AppService
  ) {}

  ngOnInit(): void {
    // Get userKey from route parameters
    this.route.params.subscribe((params) => {
      this.userKey = params["userkey"];
      if (this.userKey) {
        this.loadDashboardData();
      }
    });
  }

  async loadDashboardData() {
    try {
      this.loading = true;
      const wsJson = this.appService.get("xdbc.workspace");

      if (
        wsJson !== undefined &&
        typeof wsJson === "string" &&
        wsJson.trim() !== "" &&
        wsJson !== "undefined"
      ) {
        try {
          const ws = JSON.parse(wsJson);
          this.apiKey = ws.apiKey;
          this.workspaceName = ws.workspaceName;
          this.status = ws.status;
        } catch (err) {
          console.error("Invalid JSON:", err);
        }
      }

      if (this.status !== "ACTIVATED") {
        this.showErrorMsg = true;
        this.showErrorText =
          "The selected workspace is currently inactive. Please activate it to proceed.";
        this.loading = false;
        return;
      }

      // Load memories and tags in parallel
      await Promise.all([this.loadMemories(), this.loadTags()]);

      this.loading = false;
    } catch (error: any) {
      console.error("Error loading dashboard data:", error);
      this.showErrorMsg = true;
      this.showErrorText =
        "Failed to load dashboard data: " + (error.message || "Unknown error");
      this.loading = false;
    }
  }

  async loadMemories() {
    try {
      const payload = {
        userKey: this.userKey,
        tokens: [],
        query: "",
      };

      const signatureData = await this.appService.wssign(
        payload,
        this.workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      const response = await this.appService.wsPostRequestWithHeaders(
        payload,
        "memory/list",
        this.apiKey,
        signature
      );

      if (response && response.status === "Success") {
        this.totalMemories = response.data?.memories?.length || 0;
      } else {
        throw new Error(response?.message || "Failed to fetch memories");
      }
    } catch (error: any) {
      console.error("Error loading memories:", error);
      // Don't show error here, will be handled by parent try-catch if needed
    }
  }

  async loadTags() {
    try {
      const payload = {
        userKey: this.userKey,
      };

      const signatureData = await this.appService.wssign(
        payload,
        this.workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      const response = await this.appService.wsPostRequestWithHeaders(
        payload,
        "memory/list-tag",
        this.apiKey,
        signature
      );

      if (response && response.status === "Success") {
        this.tags = response.data?.notesTag || [];
        this.totalTags = this.tags.length;
      } else {
        throw new Error(response?.message || "Failed to fetch tags");
      }
    } catch (error: any) {
      console.error("Error loading tags:", error);
      // Don't show error here, will be handled by parent try-catch if needed
    }
  }

  goBack() {
    this.router.navigate(["/users"]);
  }

  // NEW FUNCTION: Navigate to all memories view
  viewAllMemories() {
    if (!this.loading && this.totalMemories > 0) {
      this.router.navigate(["/memories", this.userKey]);
    }
  }

  // NEW FUNCTION: Navigate to memories filtered by tag
  viewMemoriesByTag(tag: string) {
    if (!this.loading && tag) {
      this.router.navigate(["/memories", this.userKey], {
        queryParams: { tag: tag }
      });
    }
  }
}